__turbopack_context__.v({
  "check": "Checkbox-module-scss-module__JDzfWW__check",
  "danger": "Checkbox-module-scss-module__JDzfWW__danger",
  "indicator": "Checkbox-module-scss-module__JDzfWW__indicator",
  "root": "Checkbox-module-scss-module__JDzfWW__root",
});
